import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=c351fdae&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=c351fdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c351fdae",
  null
  
)

export default component.exports